<template>
    <div class="service-agreement">
      <tHeader ref="head" @getTitle="getTitle" :title="title"></tHeader>
      <div class="content">
        <div class="list" v-for="item in $t('serviceAgreement.contents')" :key="item.id">
          <template v-if="item.contentArr">
            <p v-for="(content, index) in item.contentArr" :key='index'>{{content}}</p>
          </template>
          <template v-if="!item.contentArr">
            <p v-html="item.content"></p>
          </template>
        </div>
      </div>
    </div>
</template>

<script>
import tHeader from './theader'
export default {
  name: 'service-agreement',
  components: {
    tHeader
  },
  data () {
    return {
      title: ''
    }
  },
  methods: {
    fatherMethod () {
      this.$refs.head.changeLanguage()
    },
    getTitle () {
      this.title = this.$t('serviceAgreement.title')
    }
  },
  created () {
    this.getTitle()
  }
}
</script>

<style lang="stylus">
.service-agreement{
  .content{
    padding: 18px 12px;
    .list{
      margin-bottom: 30px;
      p{
        font-size: 14px;
        line-height: 22px;
        color: #333;
        text-align: left;
      }
    }
  }
}
</style>
